import { render, staticRenderFns } from "./OnboardingChecklist.vue?vue&type=template&id=3aecf13c&"
import script from "./OnboardingChecklist.vue?vue&type=script&lang=js&"
export * from "./OnboardingChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports